import React from 'react';
import {
  Box,
  Switch,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { uk } from 'date-fns/locale';

interface SchedulingBlockProps {
  showDateTimePicker: boolean;
  onShowDateTimePickerChange: (val: boolean) => void;
  scheduledAt: Date | null;
  onScheduledAtChange: (val: Date | null) => void;
  isCompleted: boolean;
  onIsCompletedChange: (val: boolean) => void;
  switchLabel?: string;
  switchSize?: 'small' | 'medium';
  gap?: number;
}

export const SchedulingBlock: React.FC<SchedulingBlockProps> = ({
  showDateTimePicker,
  onShowDateTimePickerChange,
  scheduledAt,
  onScheduledAtChange,
  isCompleted,
  onIsCompletedChange,
  switchLabel = 'Встановити дату та час',
  switchSize = 'small',
  gap = 1,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap }}>
      <FormControlLabel
        control={
          <Switch
            checked={showDateTimePicker}
            onChange={(e) => {
              onShowDateTimePickerChange(e.target.checked);
              if (e.target.checked && !scheduledAt) {
                onScheduledAtChange(new Date());
              }
            }}
            size={switchSize}
          />
        }
        label={switchLabel}
      />
      {showDateTimePicker && (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={uk}>
          <DateTimePicker
            label="Дата та час"
            value={scheduledAt}
            onChange={(val) => onScheduledAtChange(val)}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </LocalizationProvider>
      )}
      {showDateTimePicker && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isCompleted}
              onChange={(e) => onIsCompletedChange(e.target.checked)}
            />
          }
          label="Позначити як виконане"
        />
      )}
    </Box>
  );
};
